export default "__VITE_ASSET__DY1oRak$__"